export default "__VITE_ASSET__ouW11k7b__"